import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { LandingPage } from "./pages/LandingPage/LandingPage";
import { SearchResultsPage } from "./pages/SearchResultsPage/SearchResultsPage";
import { ArticlePage } from "./pages/ArticlePage/ArticlePage";
import { CategoryPage } from "./pages/CategoryPage/CategoryPage";
// import { SubcategoryPage } from "./pages/SubcategoryPage/SubcategoryPage"; // TO DO: This will be added in Phaese 2 when subcategories have their own dedicated page
import { SearchSection } from "./components/Search/SearchSection";
import { useSyncActionBar } from "./hooks/useSyncActionBar";
import { BASE_PATH } from "./routes.constants";

export { BASE_PATH };

export const PATHS = {
  landing: BASE_PATH,
  search: `${BASE_PATH}/search`,
  article: `${BASE_PATH}/:categoryUri/:subcategoryUri/:slug`,
  subcategory: `${BASE_PATH}/:categoryUri/:subcategoryUri`,
  category: `${BASE_PATH}/:categoryUri`,
};

const SubcategoryRedirect: React.FC = () => {
  const { categoryUri } = useParams();
  return <Navigate to={`${BASE_PATH}/${categoryUri}`} replace />;
};

export const AppRoutes: React.FC = () => {
  useSyncActionBar();

  return (
    <>
      <SearchSection />
      <Routes>
        <Route path={PATHS.landing} element={<LandingPage />} />
        <Route path={PATHS.search} element={<SearchResultsPage />} />
        <Route path={PATHS.article} element={<ArticlePage />} />
        <Route path={PATHS.subcategory} element={<SubcategoryRedirect />} />
        <Route path={PATHS.category} element={<CategoryPage />} />
        <Route path="*" element={<Navigate to={BASE_PATH} replace />} />
      </Routes>
    </>
  );
};
